var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "top-menu-popup",
      style: "height: " + _vm.windowHeight + "px;"
    },
    [
      _c("div", [
        _c(
          "div",
          { staticClass: "d-flex justify-content-between" },
          [
            _c("router-link", { attrs: { to: "/" } }, [
              _c("div", { staticClass: "logo" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "close" }, [
              _c("img", {
                attrs: {
                  src: require("../../../../../assets/images/svg/white/icone_close.svg"),
                  height: "24px"
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("click")
                  }
                }
              })
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "text-center my-5 py-5 text-white" }, [
        _c("h2", [
          _c(
            "a",
            {
              staticClass: "nav-link",
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function($event) {
                  return _vm.cosaFareNY()
                }
              }
            },
            [_vm._v(_vm._s(_vm.TOP_LINK_COSA_FARE))]
          )
        ]),
        _vm._v(" "),
        _vm.TOP_LINK_CAMBIA_ISOLA !== undefined
          ? _c("h2", [
              _c(
                "a",
                {
                  staticClass: "nav-link",
                  attrs: { href: "javascript:void(0)" },
                  on: {
                    click: function($event) {
                      return _vm.cambiaIsola()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.TOP_LINK_CAMBIA_ISOLA))]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("h2", [
          _c(
            "a",
            {
              staticClass: "nav-link",
              attrs: { href: _vm.TOP_LINK_CHI_SIAMO_URL, target: "_blank" },
              on: { click: _vm.trackHomeChiSiamo }
            },
            [_vm._v(_vm._s(_vm.TOP_LINK_CHI_SIAMO))]
          )
        ]),
        _vm._v(" "),
        _c("h2", [
          !_vm.isAuthenticated()
            ? _c(
                "a",
                {
                  staticClass: "nav-link",
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.loginAgenzia }
                },
                [_vm._v(_vm._s(_vm.TOP_LINK_AGENZIA))]
              )
            : _c(
                "a",
                {
                  staticClass: "nav-link",
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.logoutAgenzia }
                },
                [_vm._v("Agenzia " + _vm._s(_vm.token()) + " - Logout")]
              )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-between p-2 text-center" },
        [
          _vm._m(0),
          _vm._v(" "),
          _vm.LOGO_EXTERNAL_1 !== undefined
            ? _c("div", [
                _c("a", {
                  staticClass: "logo1 image-contain",
                  attrs: {
                    href: _vm.LOGO_EXTERNAL_1,
                    target:
                      _vm.LOGO_EXTERNAL_1 != "javascript:void(0);"
                        ? "_blank"
                        : "_self"
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.LOGO_EXTERNAL_3 !== undefined
            ? _c("div", [
                _c("a", {
                  staticClass: "logo3 image-contain",
                  attrs: {
                    href: _vm.LOGO_EXTERNAL_3,
                    target:
                      _vm.LOGO_EXTERNAL_1 != "javascript:void(0);"
                        ? "_blank"
                        : "_self"
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("div", [
            _c("a", {
              staticClass: "logo-dx image-contain",
              attrs: { href: _vm.TOP_LINK_CHI_SIAMO_URL, target: "_blank" }
            })
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("a", {
        staticClass: "logo-sx image-contain",
        attrs: { href: "https://www.qualitygroup.it/", target: "_blank" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-logo no-wrap text-uppercase" }, [
      _c("span", [_vm._v("Un progetto")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ac4c8cd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac4c8cd6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/mobile/pages/layout/common/TopMenuPopup.vue
// module id = null
// module chunks = 